/* eslint-disable max-len */
import { Box, Button } from "@mui/material";
import { CheckboxController, GvInputController } from "../../../../components/Controllers";
import { CreateProfileFormTypeV2, CreateProfileSchemaV2 } from "../../../../services/user-create-v2/user-create.schema";
import React, { useEffect } from "react";

import { LinkExtern } from "../../../../styles/global.style";
import { Loading } from "../../../../components";
import { useForm } from "react-hook-form";
import { useTerms } from "../../../../services/terms/terms.service";
import { yupResolver } from "@hookform/resolvers/yup";

type Props = {
    onSubmit: (data: CreateProfileFormTypeV2) => void;
    hideTerms?: boolean;
}

const CreateAccountForm = (props: Props) => {
  const { onSubmit, hideTerms } = props;
  const { termsData, loading } = useTerms();

  const { control, handleSubmit, setValue, getValues } = useForm<CreateProfileFormTypeV2>({
    mode: "onSubmit",
    resolver: yupResolver(CreateProfileSchemaV2),
    defaultValues: {
      email: "",
      acceptedTerms: false,
    },
  });

  const handleEmailInputBlur = () => {
    setValue("email", getValues("email").trim().toLowerCase());
  };

  useEffect(() => {
    if (hideTerms) {
      setValue("acceptedTerms", true, { shouldValidate: true });
    }
  }, [hideTerms]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full">
      <GvInputController
        control={control}
        name="email"
        label="Email"
        placeholder="Email Address"
        onBlur={handleEmailInputBlur}
        className="font-semibold"
      />

      <div style={{ display: "grid", gridTemplateColumns: "48px auto", marginBottom: "2rem" }}>
        <CheckboxController
          control={control}
          label=""
          name="acceptedTerms"
        />
        <div style={{ color: "#908E8D", fontSize: "14px" }}>
          {loading ? <Loading size={26} sx={{ my: 2 }} /> : null}
          {termsData?.terms.map((e, index) => (
            <span key={index}>
              {e.type === "link" ? (
                <>
                  {e.content?.id === "1" && <LinkExtern href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">{e.text}</LinkExtern>}
                  {e.content?.id === "2" && <LinkExtern href="/privacy-policy" target="_blank" rel="noopener noreferrer">{e.text}</LinkExtern>}
                </>
              ) : null}

              {e.type === "text" ? index !== 4 ? <>{e.text}</> : null : null}
              {index === 4 ? <>, including Cookie Use.</> : null}
            </span>
          ))}
        </div>
      </div>

      <Box className="mt-[1.rem]">
        <Button
          id="createProfileFormButton"
          color="primary"
          type="submit"
          className="bottom-button !capitalize font-semibold text-base"
          fullWidth
        >
          Continue
        </Button>
      </Box>
    </form>
  );
};

export default CreateAccountForm;
